export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    { title: t('mnt_peso_medida.student'), field: 'student.fullName' },
    { title: t('general.date'), field: 'formattedMeasureDate' },
    { title: t('mnt_peso_medida.height'), field: 'height' },
    { title: t('mnt_peso_medida.weight'), field: 'weight' },
    { title: t('general.classes-names'), field: 'student.classesNames' },
  ];
}
